import { useEffect, useState } from 'react';
import styles from './style.module.css';
import NaviButton from '../../compoenets/NaviButton';
import NewTaskSummary from '../../compoenets/NewTaskSummary';
import useApi from '../../services/useApi';
import { useRecoilValue,useRecoilState, useSetRecoilState } from 'recoil';
import { newTaskConfig,namespaceState } from '../../recoil/atoms';
import { taskConfigDefault } from '../../constants';
import ParamsCustom from './ParamsCustom';
import TaskPreparingModal from './TaskPreparingModal';
import ErrorModal from '../../compoenets/ErrorModal';

const MainItem = ({title,subTitle=null,children})=>{
  return(
    <div className={styles['item-wrap']}>
      <span>{title}</span>
      <div className={styles['item-property']}>
        {(!subTitle||subTitle.length===0)?
        <div className={styles["item-row"]}>
          {children}
        </div>
        :
        subTitle.map((item,index)=>(
          <div key={index} className={styles["item-row"]}>
            <span>{item}</span>
            {children[index]}
          </div>
        ))}     
      </div>   
    </div>
  );
};

const ParamsItem = ({title,text})=>{
  return(
    <div className={styles["params-item"]}>
      <span>{title}</span>
      <input className={styles["params-input"]} type="number" placeholder={text}></input>
    </div>   
  );
};

export default function NewTaskTrain() {
  const taskConfig = useRecoilValue(newTaskConfig);
  const setTaskConfig = useSetRecoilState(newTaskConfig);

  const [timeoutToggle,setTimeoutToggle]=useState(taskConfig.roundTimeout);
  const [extraTimeoutToggle,setExtraTimeoutToggle]=useState(taskConfig.extraTimeout);
  const [aggAlgoToggle,setAggAlgoToggle]=useState(0);
  const [aggSelectionToggle,setAggSelectionToggle]=useState(0);
  const [taskLoading,setTaskLoading]=useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingText,setLoadingText]=useState("Preparing Task");
  const [nsState,setNsState]=useRecoilState(namespaceState);
  const [isCreateError,setIsCreateError]=useState(false);


  const handleSetTaskConfig = (name,value) =>{
    setTaskConfig((prevData) => ({
      ...prevData,
      [name]:value,
    }));
  }     

  const taskData= {
  namespaceId:nsState.id,
  taskName: taskConfig.taskName,
  userId: JSON.parse(localStorage.getItem('account')).id,
  deviceQuery: {
    model: taskConfig.deviceQuery,
    dataName: taskConfig.requiredData.toLowerCase(),
    dataSizeGte : taskConfig.dataSizeGte,
    dataSizeLte : taskConfig.dataSizeLte,
    lastUpdatedWithin : {
        day : 7,
        hour : "",
        minute : ""
      }
  },
  recipe: {
      requiredData: taskConfig.requiredData.toLowerCase(),
      initialModelId: taskConfig.initialModelId,
      initialModelName : taskConfig.initialModelName,
      aggregationAlgorithm: taskConfig.aggregationAlgorithm,
      aggregationSelectionMethod: taskConfig.aggregationSelectionMethod,
      samplingMethod: taskConfig.samplingMethod,
      minDataSize: 0,
      maxDataSize: 1000,
      numOfTargetTrainingRequestDevicesPerRound: taskConfig.numOfTargetTrainingRequestDevicesPerRound,
      numOfTargetTrainingResponseDevicesPerRound: taskConfig.numOfTargetTrainingResponseDevicesPerRound,
      numOfTargetEvaluationRequestDevicesPerRound: taskConfig.numOfTargetTrainingRequestDevicesPerRound,
      numOfTargetEvaluationResponseDevicesPerRound: taskConfig.numOfTargetTrainingResponseDevicesPerRound,
      numOfTargetTestRequestDevices : taskConfig.numOfTargetTestRequestDevices,
      numOfTargetTestResponseDevices : taskConfig.numOfTargetTestResponseDevices,
      maxRound: taskConfig.maxRound,
      targetAccuracy: 99.9,
      targetResponses: 99.9,
      roundTimeout: taskConfig.roundTimeout,
      extraTimeout: taskConfig.extraTimeout,
      samplingParameter:{
        samplingTemperature:taskConfig.samplingParameter.samplingTemperature,
        lossSelectionWeight:taskConfig.samplingParameter.lossSelectionWeight,
        algorithm:taskConfig.samplingParameter.algorithm,
        lossPriority:taskConfig.samplingParameter.lossPriority,
        referenceRound:taskConfig.samplingParameter.referenceRound,
      }
  },
  hyperparameter: {
      batchSize: parseInt(taskConfig.batchSize),
      epoch: parseInt(taskConfig.epoch),
      modelType:taskConfig.modelType,
      dropReminder:taskConfig.dropReminder,
  },
  modelParameters:{
      ...Object.keys(taskConfig.additionalParams).filter(key => taskConfig.additionalParams[key].required).reduce((acc, key) => ({...acc, [key]: {value: taskConfig.additionalParams[key].value}}), {})
  }}

  useEffect(()=>{
    if(
      !taskConfig.numOfTargetTrainingResponseDevicesPerRound ||
      !taskConfig.numOfTargetTrainingRequestDevicesPerRound
    ){
      handleSetTaskConfig("maxRound",0);
    }
  },[])

  const handleRunTask = async () => {
    if(!handleNext()){
      return;
    }

    setTaskLoading(true);
    useApi.post('ngp/fl/task/create',taskData)
    .then((response) => {
        setLoading(true);
        if (response.status === 200) {
            setTaskConfig(taskConfigDefault);
            setLoadingText('Task Run Complete')
        } else {
            setLoadingText('Task Run Fail')
        }
    },(error) => {
      setLoading(true);
      if(error.response.status==403){
        setTaskLoading(false);
        setIsCreateError(true);
      }
      else if(error.response.data.message.startsWith("task start fail")){
          setTaskConfig(taskConfigDefault);
          setLoadingText('Task add success, But start fail')
      }else{
          setLoadingText('Task Run Fail')
      }
    })
  }

  const handleNext=()=>{
    let rejectText="";
    if(taskConfig.taskName=="")rejectText+="- Task Name\n"
    if(taskConfig.numOfTargetTrainingRequestDevicesPerRound
        &&taskConfig.numOfTargetTrainingResponseDevicesPerRound
      ){
      if(taskConfig.maxRound==""||taskConfig.maxRound==0)rejectText+="- Rounds\n"
      if(taskConfig.epoch==""||taskConfig.epoch==0)rejectText+="- Epoch\n"
      if(taskConfig.batchSize==""||taskConfig.batchSize==0)rejectText+="- Batch Size\n"
    }

    if(rejectText=="") return true;
    else { 
      alert("다음 화면으로 진행 할 수 없습니다. 내용을 확인해 주세요.\n"+rejectText);
      return false;
    }
  }

  return (
    <>
    <div className={styles["NewTaskTrain-wrap"]}>
      <div className={styles["NewTaskTrain-header"]}>
        <span>New Task<p>&gt;</p>Training Setting</span>
        <div className={styles["header-btn-wrap"]}>
          <NaviButton to="/new-task-device" className={`${styles["header-btn"]} ${styles["header-btn-prev"]}`}><p>&lt;</p>Device Clustering</NaviButton>
          <div
          className={`${styles["header-btn"]} 
          ${styles["header-btn-next"]}`}
          onClick={handleRunTask}
          >Run Task</div>
        </div>
      </div>
      <div className={styles["NewTaskTrain-body"]}>
        <div className={styles["body-main"]}>
          <MainItem title='Task Name'>
              <input className={styles["rounds-input"]} 
              value={taskConfig.taskName}
              onChange={(e)=>{handleSetTaskConfig("taskName",e.target.value)}} placeholder='write name'></input>
          </MainItem>
          <MainItem title='Aggregation' subTitle={['Algorithm','Selection Method']}>
            <div className={styles["aggAlgo-btn-wrap"]}>
              <button className={`${styles["aggAlgo-btn"]} ${aggAlgoToggle==0 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggAlgoToggle(0);handleSetTaskConfig("aggregationAlgorithm","FedAvg")}}>FedAvg</button>
              <button className={`${styles["aggAlgo-btn"]} ${aggAlgoToggle==1 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggAlgoToggle(1);handleSetTaskConfig("aggregationAlgorithm","FedAvgM")}}>FedAvgM</button>
              <button className={`${styles["aggAlgo-btn"]} ${aggAlgoToggle==2 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggAlgoToggle(2);handleSetTaskConfig("aggregationAlgorithm","FedMom")}}>FedMom</button>
              <button className={`${styles["aggAlgo-btn"]} ${aggAlgoToggle==3 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggAlgoToggle(3);handleSetTaskConfig("aggregationAlgorithm","FedProx")}}>FedProx</button>
              <button className={`${styles["aggAlgo-btn"]} ${aggAlgoToggle==4 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggAlgoToggle(4);handleSetTaskConfig("aggregationAlgorithm","qFedAvg")}}>qFedAvg</button>
            </div>
            <div className={styles["aggAlgo-btn-wrap"]}>
              <button className={`${styles["aggSelection-btn"]} ${aggSelectionToggle==0 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggSelectionToggle(0);handleSetTaskConfig("aggregationSelectionMethod","FIRST_COME")}}>First Come</button>
              <button className={`${styles["aggSelection-btn"]} ${aggSelectionToggle==1 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggSelectionToggle(1);handleSetTaskConfig("aggregationSelectionMethod","LEAST_PARTICIPATED")}}>Least Participated</button>
              <button className={`${styles["aggSelection-btn"]} ${aggSelectionToggle==2 && styles["aggAlgo-btn-clicked"] }`} onClick={()=>{setAggSelectionToggle(2);handleSetTaskConfig("aggregationSelectionMethod","LOSS_ASC")}}>Loss ASC</button>
            </div>
          </MainItem>
          <MainItem title='Rounds' subTitle={['Rounds Num','Timeout Per Round','Extra Time Per Round']}>
            <input className={styles["rounds-input"]}type="number" 
            disabled={
              (!taskConfig.numOfTargetTrainingResponseDevicesPerRound
              ||!taskConfig.numOfTargetTrainingRequestDevicesPerRound
              )?true:false
            }
            value={taskConfig.maxRound!=0 && taskConfig.maxRound}
            onChange={(e)=>{handleSetTaskConfig("maxRound",e.target.value)}} placeholder='0'></input>
            <div className={styles["timeout-btn-wrap"]}>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==15 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(15);handleSetTaskConfig("roundTimeout",15)}}>15s</button>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==30 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(30);handleSetTaskConfig("roundTimeout",30)}}>30s</button>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==600 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(600);handleSetTaskConfig("roundTimeout",600)}}>10m</button>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==900 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(900);handleSetTaskConfig("roundTimeout",900)}}>15m</button>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==3600 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(3600);handleSetTaskConfig("roundTimeout",3600)}}>1h</button>
              <button className={`${styles["timeout-btn"]} ${timeoutToggle==86400 && styles["timeout-btn-clicked"] }`} onClick={()=>{setTimeoutToggle(86400);handleSetTaskConfig("roundTimeout",86400)}}>24h</button>
            </div>
            <div className={styles["timeout-btn-wrap"]}>
              <button className={`${styles["timeout-btn"]} ${extraTimeoutToggle==0 && styles["timeout-btn-clicked"] }`} onClick={()=>{setExtraTimeoutToggle(0);handleSetTaskConfig("extraTimeout",0)}}>0s</button>
              <button className={`${styles["timeout-btn"]} ${extraTimeoutToggle==15 && styles["timeout-btn-clicked"] }`} onClick={()=>{setExtraTimeoutToggle(15);handleSetTaskConfig("extraTimeout",15)}}>15s</button>
              <button className={`${styles["timeout-btn"]} ${extraTimeoutToggle==30 && styles["timeout-btn-clicked"] }`} onClick={()=>{setExtraTimeoutToggle(30);handleSetTaskConfig("extraTimeout",30)}}>30s</button>
              <button className={`${styles["timeout-btn"]} ${extraTimeoutToggle==60 && styles["timeout-btn-clicked"] }`} onClick={()=>{setExtraTimeoutToggle(60);handleSetTaskConfig("extraTimeout",60)}}>1m</button>
            </div>
          </MainItem>
          <MainItem  title='Hyperparameters' subTitle={["Epoch","Batch Size"]}>
            <input className={styles["rounds-input"]} type="number" placeholder='1'
            disabled={
              (!taskConfig.numOfTargetTrainingResponseDevicesPerRound
              ||!taskConfig.numOfTargetTrainingRequestDevicesPerRound
              )?true:false
            }
            value={taskConfig.epoch!=0 && taskConfig.epoch}
            onChange={(e)=>{handleSetTaskConfig("epoch",e.target.value)}}
            ></input>
            <input className={styles["rounds-input"]} type="number" placeholder='1'
            disabled={
              (!taskConfig.numOfTargetTrainingResponseDevicesPerRound
              ||!taskConfig.numOfTargetTrainingRequestDevicesPerRound
              )?true:false
            }
            value={taskConfig.batchSize!=0 && taskConfig.batchSize}
            onChange={(e)=>{handleSetTaskConfig("batchSize",e.target.value)}}
            ></input>
          </MainItem>
          <MainItem  title='Model Parameters'>
            <ParamsCustom />
          </MainItem>
        </div>
        <NewTaskSummary target={["data","device"]}></NewTaskSummary>
      </div>
    </div>
    { taskLoading &&
    <TaskPreparingModal
      isDone={loading}
      text={loadingText}
      onClick={()=>{
        setTaskConfig(taskConfigDefault);
        window.location.href = '/task-list'
      }}
    />
    }
    {isCreateError&&<ErrorModal
      title="Permission Denied"
      subTitle={"사용자의 `Task Create` 권한이 없습니다."}
      onClose={()=>setIsCreateError(false)}
    />}
    </>
  );
}